<template>
    <div class="sitemap">
        <div class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24">
            <h3
                class="text-2xl lg:text-5xl text-primary font-semibold tracking-wide mb-16"
            >
                Site Map
            </h3>
            <div class="mt-16">
                <p class="text-xl font-bold mb-8">Quick Links</p>
                <div
                    class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 mb-16"
                >
                    <nuxt-link to="/">Home</nuxt-link>
                    <nuxt-link to="/stores">Stores</nuxt-link>
                    <nuxt-link to="/news-and-events">News/Events</nuxt-link>
                    <nuxt-link to="/offers">Offers</nuxt-link>
                    <nuxt-link to="/about">About Us</nuxt-link>
                    <nuxt-link to="/visit">Visit Us</nuxt-link>
                    <nuxt-link to="/services">Services</nuxt-link>
                    <nuxt-link to="/jobs">Jobs</nuxt-link>
                    <nuxt-link to="/commercial-and-leasing"
                        >Commercial & leasing</nuxt-link
                    >
                    <nuxt-link to="/contact-us">Contact Us</nuxt-link>
                    <nuxt-link to="/accessibility">Accessibility</nuxt-link>
                    <nuxt-link to="/terms-and-conditions"
                        >Terms and Conditions</nuxt-link
                    >
                    <nuxt-link to="/privacy-policy">Privacy Policy</nuxt-link>
                </div>
                <p class="text-xl font-bold mb-8">Stores</p>
                <div
                    class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 mb-16"
                >
                    <nuxt-link to="/stores">All Stores</nuxt-link>
                    <nuxt-link to="/kids">Kids Stores</nuxt-link>
                    <nuxt-link to="/students">Students Stores</nuxt-link>
                    <nuxt-link to="/dine-drink">Dine & Drink</nuxt-link>
                    <nuxt-link to="/the-collective">The Collective</nuxt-link>
                </div>
                <p class="text-xl font-bold mb-8">Community</p>
                <div
                    class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 mb-16"
                >
                    <nuxt-link to="/we-care/creative-crawley"
                        >Creative Crawley</nuxt-link
                    >
                    <nuxt-link to="/we-care/wormery">Wormery</nuxt-link>
                    <nuxt-link to="/we-care/the-easter-team"
                        >The Easter Team
                    </nuxt-link>
                    <nuxt-link to="/we-care/crawley-town-centre-bid"
                        >Crawley Town Center BID</nuxt-link
                    >
                    <nuxt-link to="/we-care/hidden-disabilities-scheme"
                        >Hidden Disabilities Scheme</nuxt-link
                    >
                    <nuxt-link to="/we-care/0-landfill-waste"
                        >0% Landfill Waste</nuxt-link
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.sitemap {
    a {
        font-size: 16px;
        color: $brand-secondary;
        letter-spacing: 1px;
        margin-bottom: 16px;
        &.heading {
            font-size: 20px;
            font-weight: 700;
        }
        &:hover {
            color: $text;
        }
    }
    .links {
        a {
            margin-bottom: 16px;
            display: block;
        }
    }
}
</style>
